<template>
  <div id="app">
    
    <header>
      <app-header></app-header>
    </header>

    <section>
      <transition appear name="fade" mode="out-in"> 
        <router-view></router-view>
      </transition>
    </section>

    <footer>
      <app-footer></app-footer>
    </footer>

  </div>
</template>

<script>
  import Header from './components/Header.vue';
  import Footer from './components/Footer.vue';

  export default {
    components: {
      appHeader: Header,
      appFooter: Footer
    }
  }
</script>

<style>

@import './assets/css/normalize.css';
@import './assets/css/bootstrap-grid.min.css';

@font-face {
  font-family: 'OpenSans';
  font-display: auto;
  src: local('OpenSans'), url('/static/fonts/OpenSans-Regular.woff2') format('woff2'),
       url('/static/fonts/OpenSans-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'OpenSans';
  font-display: auto;
  src: local('OpenSans'), url('/static/fonts/OpenSans-SemiBold.woff2') format('woff2'),
       url('/static/fonts/OpenSans-SemiBold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

html {
  scroll-behavior: smooth;
}

* {
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  background: #F0F0F0;
  font-family: 'OpenSans', sans-serif;
  line-height: 1.5;
  font-weight: normal;
  font-size: 1rem;
  color: #333;
}
header {
  background: #003366;
  padding: 4rem 0;
  background-image: url(/static/intro.svg);
  background-position: top right;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
footer {
  background: #FFF;
  padding: 4rem 0;
}
section {
  min-height: 100vh;
  padding: 2rem 0;
}



input,
textarea,
select {
  width: 100%;
  padding: 0 1rem;
  line-height: 1rem;
  border-radius: 5px;
  border: 1px solid #CCC;
  box-sizing: border-box;
  height: 50px;
}
input[type="submit"] {
  background: #003366;
  color: #FFF;
  cursor: pointer;
  font-weight: bold;
}
textarea {
  padding: 1rem;
  height: auto;
}


input:hover,
input:focus,
textarea:focus {
  outline: none;
}
button {
  background: #f0f0f0;
  color: #333;
  border: none;
  outline: none;
  padding: 1rem 2rem;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  height: 50px;
}



table {
  width: 100%;
  overflow-x: auto;
  text-align: center;
  margin-top: 1rem;
}
table caption {
  color: #003366;
  padding: 1rem 0;
  text-align: left;
  font-weight: bold;
  font-size: 1.4rem;
}
table thead {
  font-weight: normal;
}
table thead th {
  background: #003366;
  color: #FFF;
}
table td, table th {
  padding: 1rem;
}
table tr:nth-child(2n+1) {
  background: #FFF;
}

@media only screen and (max-width: 768px) {

  header {
    padding: 1rem 0;
  }
  section {
    padding: 1rem 0;
  }
  table {
    display: block;
    white-space: nowrap;
  }
  footer {
    padding: 1rem 0;
  }
}





.note {
  background: #FFF;
  margin: 2rem 0;
  padding: 1rem 2rem;
  border: 1px dashed #CCC;
}


/* Анимация перехода между компонентами */

.fade-enter-active, .fade-leave-active {
  transition: all .3s ease;
  transform: translateY(0);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(150px);
}

/* Спиннер */

.spinner {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.spinner div {
  display: inline-block;
  position: absolute;
  left: 6px;
  width: 13px;
  background: #003366;
  animation: spinner 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.spinner div:nth-child(1) {
  left: 6px;
  animation-delay: -0.24s;
}
.spinner div:nth-child(2) {
  left: 26px;
  animation-delay: -0.12s;
}
.spinner div:nth-child(3) {
  left: 45px;
  animation-delay: 0;
}
@keyframes spinner {
  0% {
    top: 6px;
    height: 51px;
  }
  50%, 100% {
    top: 19px;
    height: 26px;
  }
}


@media only screen and (max-width: 768px) {
  h1 {
    font-size: 1.3rem;
    margin: 0.5rem 0;
  }
  h2 {
    font-size: 1.1rem;
    margin: 0.5rem 0;
  }
  .note {
    margin: 1rem 0;
    padding: 1rem;
  }
  ul {
    padding-left: 1.2rem;
  }
}


</style>



// WEBPACK FOOTER //
// src/App.vue